import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";

import {setContractIMEFieldsValues, setContractSigningStep, setContractsList} from "../../../actions/contractsActions";
import {
  getAllContractsValues,
  setContractBlobs
} from "./contractsFunctions";
import LoadingSpinner from "../../ui/loadingSpinner";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import ContractsPopupSuccess from "./contractsPopupSuccess";
import ContractsPopupDocument from "./contractsPopupDocument";
import ContractsContext, {initialContext} from "./contractsContext";
import {getCurrentReceiptPages} from "../../../actions/printFunctions";
import {showOrderCompletePopup} from "../../../actions/shoppingCartFunctions";
import {toggleShowAssignQuotePopup} from "../../../actions/assignPopupFunctions";
import Config, {IS_AS_WORK_ORDER} from "../../../config";
import {ASYNC_SCRIPTS} from "../../../loadingLogic";
import {loadScriptPromise} from "../../../misc/loadScript";
import {setUiPopupState} from "../../../actions/actionFunctions";
import {UI_POPUP_TYPES} from "../../../reducers/messageBoxReducer";


const ContractsPopup = (props) => {

  const {contractsList, setContractsList, isSignaturePadVisible, step, contractsReceived, fabricatorData,
    showOrderCompletePopup, toggleShowAssignQuotePopup, showAssignQuotePopup, setContractSigningStep,
    visualizersLoadedLength, signedDocumentUrl, setUiPopupState, setContractIMEFieldsValues} = props;

  const fabricatorSettings = fabricatorData.settings;

  const history = useHistory();
  const [context, setContext] = useState(initialContext);

  const showReceiptInContract = true; // to change on fab setting if needed

  const checkContractBlobs = async () => {
    if (!visualizersLoadedLength) {
      return
    }
    if (fabricatorData.isAmericanStandard && IS_AS_WORK_ORDER) {
      showImePopup();
    } else {
      loaderEnable("loader.contractSignMessage", "loader.contractSignTitle");
    }
    await loadScriptPromise(ASYNC_SCRIPTS.bundleReactPdf, "bundleReactPdf");
    let receiptUrl = context.receiptUrl,
      receiptPages = context.receiptPages,
      receiptLayout = context.receiptLayout;
    if (showReceiptInContract) {
      const contractData = await getCurrentReceiptPages(true);
      receiptUrl = contractData.receiptUrl;
      receiptPages = contractData.receiptPages;
      receiptLayout = contractData.receiptLayout;
      console.log("contractData", contractData);
    }
    const {updatedContractsList, totalPages} = await setContractBlobs(contractsList, receiptPages);
    setContext({...context, totalPages, receiptUrl, receiptPages, showReceiptInContract, receiptLayout});
    setContractsList([...updatedContractsList]);
    loaderDisable();
  }

  useEffect(() => {
    if (step !== 1) {
      setContractSigningStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contractsReceived) {
      checkContractBlobs();
      if (showAssignQuotePopup) {
        toggleShowAssignQuotePopup(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractsReceived, visualizersLoadedLength]);

  const closeContracts = () => {
    history.push("/shoppingcart");
    //should we show order complete if contract wasn't signed?
    if (signedDocumentUrl && fabricatorSettings.checkout && (!fabricatorSettings.hasPaymentGateway || window.checkoutSuccess)) {
      showOrderCompletePopup(true)
    } else if (document.kvConfig.isBackend) {
      toggleShowAssignQuotePopup(true)
    }
  }

  const saveIMEContractValues = useCallback((closePopup, popupContext) => {
    if (Config.isDevMode()) {
      console.log("saveIMEContractValues", popupContext);
    }
    setContractIMEFieldsValues(popupContext.IMEFieldsValues);
    closePopup();
  }, [setContractIMEFieldsValues]);

  const showImePopup = () => {
    setUiPopupState({
      headerTextId: "overlays.specifications",
      className: "",
      style: {maxWidth: "560px", maxHeight: "520px"},
      opened: true,
      type: UI_POPUP_TYPES.imeValues,
      context: {},
      onCloseClick: (isCancel) => {
        if (isCancel) {
          closeContracts();
        }
      },
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button2 text-uppercase ui-button2--green ml-1",
        textId: "buttons.save",
        onClick: saveIMEContractValues,
      }],
    });
  };

  const allValues = getAllContractsValues(contractsList, context);
  if (Config.isDevMode()) {
    console.log("allValues", allValues);
  }

  if (!contractsReceived || allValues.selectedContracts.some(contract => !contract.blobUrl)
    || (!showReceiptInContract && !allValues.activeContract)) {
    return <LoadingSpinner/>
  }

  const isFinished = step === 3;

  const changeContext = (newContextValues) => {
    setContext({...context, ...newContextValues});
  };

  return (
    <ContractsContext.Provider value={allValues} setContext={setContext}>
      <div
        className={"overlay overlay--contract" + (isSignaturePadVisible ? " overlay--contract-with-popup" : "")}>
        <button className="ui-close contract-close-button" style={{right: "40px"}} onClick={closeContracts}/>
        {isFinished
          ? <ContractsPopupSuccess closeSignPopup={closeContracts}/>
          : <ContractsPopupDocument changeContext={changeContext}/>}
      </div>
    </ContractsContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {contractsList, isVisible, step, contractsReceived, signedDocumentUrl} = store.contractSigningState;
  const {showAssignQuotePopup} = store.assignQuoteState;

  return {
    contractsList,
    contractsPopupOpened: isVisible,
    step,
    contractsReceived,
    fabricatorData: store.fabricatorState,
    showAssignQuotePopup,
    visualizersLoadedLength: store.serverState.visualizersLoaded.length,
    signedDocumentUrl,
  };
};

const mapDispatchToProps = {
  setContractsList,
  showOrderCompletePopup,
  toggleShowAssignQuotePopup,
  setContractSigningStep,
  setUiPopupState,
  setContractIMEFieldsValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsPopup)
